module.exports = __webpack_public_path__ + "static/img/Teahupoo-Tahiti.8886e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Teahupoo-Tahiti.jpg
// module id = XQee
// module chunks = 0